
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-registry-node-anchor-demo-node-anchor-playground"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/registry/node-anchor.zh.md?type=demo')
};